<template>
    <div class="subscription-manager-v3">
        <h2 class="subscription-manager-v3__title typographies-heading-h2">
            {{ $l10n.__('Mon abonnement Sellsy') }}
        </h2>
        <CompassTabs v-model="currentTab">
            <CompassTabPane :label="$t.__('common.labels.subscription')" name="subscription">
                <ChargebeeSubscriptionOverviewV3
                    :licenseAssignement="licenseAssignement"
                    :chargebeeThirdPartyPayerId="chargebeeThirdPartyPayerId"
                />
            </CompassTabPane>
            <CompassTabPane
                :label="$t.__('common.labels.invoices_and_credit_notes')"
                name="invoice"
                :disabled="!documents.length"
            >
                <documents :documents="documents" :isChargebeeProvider="true" />
            </CompassTabPane>
        </CompassTabs>
    </div>
</template>
<script>
import ChargebeeSubscriptionOverviewV3 from 'vcomponents/sellsyaccountmanager/SubscriptionManager/chargebeeSubscriptionManagerV3/ChargebeeSubscriptionOverviewV3.vue';
import Documents from 'vcomponents/sellsyaccountmanager/SubscriptionManager/Documents.vue';
import subscription from 'api/sellsyaccountmanager/subscription';
export default {
    components: { Documents, ChargebeeSubscriptionOverviewV3 },
    props: {
        chargebeeThirdPartyPayerId: {
            type: String,
            default: '',
        },
        licenseAssignement: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            currentTab: 'subscription',
            documents: [],
        };
    },
    created() {
        subscription.getDocuments()
            .then((documents) => {
                this.documents = documents;
            })
            .catch(() => {
                this.$pushToast({
                    text: this.$l10n.__(
                        'Une erreur est survenue lors de la récuperation de vos factures, merci de contacter le support',
                    ),
                    type: 'error',
                    icon: false,
                });
            });
    },
};
</script>

<style scoped lang="scss">
.subscription-manager-v3 {
    &__title {
        margin: 0 0 var(--spacing-4);
    }
}
</style>
